import React from "react";
// import Navbar from "react-bootstrap/Navbar";
// import { useIsAuthenticated } from "@azure/msal-react";
import { SignInButton } from "./SignInButton";

/**
 * Renders the navbar component with a sign-in button if a user is not authenticated
 */
const PageLayout = () => {
  return (
    <div>
      <div className="alert alert-secondary" role="alert">
        Aquta.io - Data Sciences (M) Sdn. Bhd.
      </div>
      <div className="container">
        <div className="row">
          <div className="col text-center">
            <div className="alert alert-light" role="alert">
              <p>This app will read the following logs:</p>
              <p>
                <a
                  href="https://docs.microsoft.com/graph/permissions-reference?WT.mc_id=Portal-Microsoft_AAD_RegisteredApps"
                  className="alert-link"
                >
                  Audit Logs
                </a>
              </p>
              <p>
                <a
                  href="https://docs.microsoft.com/en-us/office/office-365-management-api/office-365-management-activity-api-reference"
                  className="alert-link"
                >
                  Office 365 Activities (SharePoint & Exchange)
                </a>
              </p>
            </div>
            <SignInButton />
          </div>
        </div>
      </div>
    </div>
  );
};
export default PageLayout;
